export default __webpack_public_path__ + "static/media/SOL.5bef7775.jpg";